export default __webpack_public_path__ + "static/media/allen.485253d6.png";